import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';

import cx from 'classnames';
import get from 'lodash/get';
import CheckBoxToggle from '../../../components/Common/CheckBoxToggle';
// import { DinamicParamsForm } from '../../../components/KnowledgeBase/Main/utils';
import { reduxForm } from 'redux-form';
import { createCheckPropsFunction } from '../../../helpers';
import { initializeDynamicParams } from 'pages/Appeal/helpers';
import { escapeBaseTag } from 'helpers';
import { withTranslation } from 'react-i18next';
import DynamicForm from "../../Ordering/common/DynamicForm"
import GlobalFile from '../../Ordering/common/GlobalFile';
// import CommentFile from '../../Ordering/common/CommentSection/CommentFile';

@withTranslation()
@reduxForm()
class KnowledgeBaseItemField extends React.Component {
    componentDidUpdate(prevProps) {
        const { field, initialize } = this.props;
        const isPropChanged = createCheckPropsFunction(prevProps.field, field);

        if (field.name === 'dynParams' && field.value && isPropChanged('value')) {
            const block = initializeDynamicParams({ blocks: field.value });
            initialize({ block });
        }
    }

    getFiles = () => {
        const { field } = this.props;

        const files = field.value.map((file, index) => (
            // <div className="fileLinkWrapper" key={file.id}>
            //     <a
            //         target="_blank"
            //         href={`../mw/file?fileId=${file.id}&download=0`}
            //         className="fileLink"
            //     >
            //         {file.fileName}
            //     </a>
            //     <a
            //         target="_blank"
            //         href={`../mw/file?fileId=${file.id}&download=1`}
            //         className="fileLink"
            //     >
            //         <ReactSVG className="svg-download" src="/data/svg/download.svg" />
            //     </a>
            // </div>
            <GlobalFile key={index} fileId={file.id} fileName={file.fileName} fileSize={file.fileSize} removable={false} deleteFile={null} />
        ));

        return <div className="filesWrapper">{files}</div>;
    };

    getStatusContent = () => {
        const { value: status } = this.props.field;

        const wrapperClassName = cx('status-select-wrapper', 'inline', 'disabled');

        const resolutionName = get(status, 'resolution.title', '');

        return (
            <div className={wrapperClassName} onClick={this.openStatusPopup}>
                {status.name && (
                    <span className={`sticker sticker-${status.code}`}>{status.name}</span>
                )}
                {resolutionName && (
                    <Fragment>
                        <span className="status-divider">|</span>
                        <span className="resolution">{resolutionName}</span>
                    </Fragment>
                )}
                {!status.name && !resolutionName && "-"}
            </div>
        );
    };

    // renderDynParams = (block) => {
    //     let widgets = block.widgets;

    //     return (
    //         <div className="formBlock viewMode" key={block.key}>
    //             {block.title && block.title !== '*' && (
    //                 <div className="formBlockTitle">{block.title}</div>
    //             )}
    //             {block.description && <div className="formBlockDescription">{block.description}</div>}
    //             <div className={cx('view', `view${block.view}`)}>
    //                 <DinamicParamsForm
    //                     blockKey={block.key}
    //                     widgets={widgets}
    //                     skipRestriction={true}
    //                     viewMode={true}
    //                 />
    //             </div>
    //         </div>
    //     );
    // };

    renderFieldContent = () => {
        const { field } = this.props;
        switch (field.name) {
            case 'status':
                return this.getStatusContent();

            case 'file':
                return <div className="description">{this.getFiles()}</div>;

            case 'checkbox':
                return (
                    <div className="description">
                        <CheckBoxToggle
                            input={{ value: field.value }}
                            label={field.checkBoxLabel}
                        />
                    </div>
                );

            // case "dynParams":
            //     // console.log({value: field.value});
            //     return field.value && field.value.map(this.renderDynParams);

            default:
                return <div dangerouslySetInnerHTML={{ __html: escapeBaseTag(field.value) }} />;
        }
    };

    render() {
        const { field } = this.props;
        if (field.name === "dynParams") {
            return (
                <DynamicForm
                    t={this.props.t}
                    currentId={this.props.id}
                    formName={this.props.form}
                    dynData={field.value}
                    withoutLiveSave
                    readonly
                    withAjaxAndFilesExValue // we need that in order to get labels for files and ajaxCombo search values
                />
            );
        }
        return (
            <div className={cx("block", { "status-block": field.name === "status" })} key={field.label}>
                <div className={cx("title", { "status-title": field.name === "status" })}>
                    {field.label && field.label}
                </div>
                {this.renderFieldContent()}
            </div>
        );
    }
}

KnowledgeBaseItemField.propTypes = {
    field: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.any,
        name: PropTypes.string,
    }),
};

export default KnowledgeBaseItemField;
